////////EF 4.1 schema
const fourOneSchema = {
  title: "4_1 Goods Purchased by an Organization",
  cat: "4_1",
  catName: "cat4",
  progressiveOrderSwitch: {
    by: { level: 2, key: "computationMethod" },
  },
  fields: [
    {
      key: "title",
      type: "title",
      title: "Emission Factor",
    },
    ////////Data Source
    {
      key: "emissionFactorTypeId",
      level: 1,
      type: "select",
      label: "Data Source",
      optionsAPI: "emissionFactorDropdown",
      autoFillNum: 0,
    },
    ////////Computation Method
    {
      key: "computationMethod",
      level: 2,
      type: "select",
      label: "Computation Method",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        value: "4_1",
      },
      showIf: { level: 1, key: "emissionFactorTypeId", ne: "2" },
      combineKey: 1,
    },
    ////////Emission Factor Database Source
    {
      key: "sourceEFName",
      level: 3,
      type: "select",
      label: "Emission Factor Database Source",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 2,
        key: "computationMethod",
      },
      showIf: { level: 2, key: "computationMethod", notEmpty: true },
      combineKey: 2,
    },
    //////// Material / Product / Asset Type
    {
      key: "assetType",
      level: 4,
      type: "select",
      label: "Material / Product / Asset Type",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 3,
        key: "sourceEFName",
      },
      showIf: { level: 3, key: "sourceEFName", notEmpty: true },
      combineKey: 3,
    },
    ////////Emission Factor Name (非自定義)
    {
      key: "emissionFactorId",
      level: 5,
      type: "select",
      label: "Material / Product / Asset Name",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 4,
        key: "assetType",
      },
      showIf: {
        level: 4,
        key: "assetType",
        notEmpty: true,
      },
      combineKey: 4,
    },
    ////////Emission Factor Name (自定義)
    {
      key: "emissionFactorId",
      addBtn: true,
      level: 5,
      type: "select",
      custom: true,
      label: "Emission Factor Name",
      optionsAPI: "cat4CustomEFDropdownList",
      showIf: {
        level: 1,
        key: "emissionFactorTypeId",
        eq: "2",
      },
      autoFillNum:0,
    },
  ],
};

export default fourOneSchema;
